<div class="request-update-modal">
  <div class="modal-body">
    <p class="lead">
      Please select the employee for reassignment of this application.
    </p>

    <nz-spin nzSize="large" *ngIf="isLoading"></nz-spin>

    <ng-container *ngIf="!isLoading && !selectedCaseOfficer">
      <ng-container *ngIf="caseOfficers?.length != 0; else emptyCaseOfficers">
        <label class="field-label">
          <span>Select Areas for Update</span>
          <span class="optional">(optional)</span>
          <i
            nz-icon
            nzType="question-circle"
            nz-tooltip
            nzTooltipTitle="Choose the sections that need revision"
          ></i>
        </label>

        <div class="officer-list">
          <ng-container *ngFor="let item of caseOfficers">
            <div
              (click)="onChooseOfficer(item)"
              class="officer-item">
              <div>
                <nz-avatar nzIcon="user" class="avatar"></nz-avatar>
              </div>
              <div>
            <span>
              {{item.firstName}} {{item.lastName}}
            </span>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-template #emptyCaseOfficers>
        <div class="emptyList">
          <nz-empty
            nzNotFoundImage="simple"
            [nzNotFoundContent]="contentTpl"
          >
            <ng-template #contentTpl>
              <span style="color: rgba(0, 37, 84, 0.45)">
                No available Case Officers have been found.
              </span>
            </ng-template>
          </nz-empty>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="selectedCaseOfficer">
      <div class="officer-item" style="margin-bottom: 8px; justify-content: space-between">
        <div>
          <nz-avatar nzIcon="user" class="avatar"></nz-avatar>
          <span>
            {{selectedCaseOfficer.firstName}} {{selectedCaseOfficer.lastName}}
          </span>
        </div>
        <div>
          <button nz-button (click)="onChooseOfficer(null)" nzType="text" nzShape="circle">
            <i nz-icon nzType="close"></i>
          </button>
        </div>
      </div>
      <textarea
        rows="6"
        nz-input maxlength="4000" 
        class="w-100"
        [(ngModel)]="reason"
        placeholder="Please provide a reason for the reassignment."
      ></textarea>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button nz-button nzType="default" (click)="cancel()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      class="btn-confirm"
      (click)="confirm()"
      [disabled]="!selectedCaseOfficer"
    >
      Reassign
    </button>
  </div>
</div>
